import React from 'react'
import { ButtonIconView } from './ButtonIconView'

export const ButtonIcon = ({
  tooltipText,
  iconName,
  iconColor,
  size,
  style = {},
  onClick = () => null
}: {
  tooltipText?: string
  iconName: string
  iconColor: string
  size: number
  style?: object
  onClick?: () => void
}): JSX.Element => {
  return (
    <ButtonIconView
      tooltipText={tooltipText}
      iconName={iconName}
      iconColor={iconColor}
      size={size}
      style={style}
      onClick={(!!onClick && (() => { onClick() })) || (() => null)}
    ></ButtonIconView>
  )
}
